// Mock for @progress/kendo-licensing — suppresses license warnings without paying
module.exports = {
  validatePackage: function() { return true; },
  setScriptKey: function() {},
  getLicenseStatus: function() { return { isLicenseValid: true }; },
  registerLicenseMessage: function() { return function() {}; },
};
